<template>
  <div class="container-box" v-loading="oLoading.pageLoading">
    <QS-scroller-box>
     <QS-h3-title>
      <template slot="title">{{ pageTitle }}</template>
      <div class="splitline" />
    </QS-h3-title>
    <QS-h4-title title="方案基本信息" />
    <!--方案id和创建时间单独提出来，解决编辑时排版混乱的问题-->
    <form-text-box
      v-if="isEdit"
      :dataList="baseEditConfig"
      :model="baseDefaultValue"
      :column="2"
    />
    <form-text-box
      ref="baseSearchBox"
      :dataList="baseCloumn"
      :model="baseDefaultValue"
      :column="2"
      :rules="baseRules"
    />
    <QS-h4-title title="租赁规则配置" />
    <!-- 确认租赁信息 -->
    <schemeRentInfo
      ref="schemeRentInfo"
      :defaultRentInfo="leaseInfoParams"
      :tableData="defaultTable"
      :showPreFreeRentDays="false"
      @updateInfo="updateRentDateInfo"
    />
    <!-- 租赁支付计划表格 -->
    <schemeRentLeasePlanInfo
      ref="schemeRentLeasePlanInfo"
      :rentDateInfo="rentDateInfo"
      :defaultTableData="feeTableData"
      @autoAnchor="autoAnchor"
    />
     <template slot="bottomAction">
        <el-button @click="handleCancel" size="mini">取消</el-button>
        <el-button
          v-if="hasSubmitPermission"
          :loading="oLoading.submit"
          type="primary"
          size="mini"
          @click="submitHandle"
        >提交</el-button>
     </template>
   </QS-scroller-box>
 </div>
</template>
<script>
import { saveEnterprisePlan, getEnterprisePlanDetail } from '@/api/domain/leaseScheme'
import schemeRentInfo from '@/components/rentCalculateConfig/schemeRentInfo.vue'
import schemeRentLeasePlanInfo from '@/components/rentCalculateConfig/schemeRentLeasePlanInfo.vue'
import { MODE_TYPE, MODE_TYPE_TEXT, ENTERPRISE_PLAN_STATUS } from './const'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'EnterprisePlanFormBody',
  components: {
    schemeRentInfo,
    schemeRentLeasePlanInfo,
  },
  props: {
    mode: {
      type: String,
      default: MODE_TYPE.ADD,
    },
  },
  data() {
    return {
      leaseInfoParams: {
        rentCategory: 1,
        rentPeriod: '',
        presentDays: '',
        rentPeriodType: '',
      },
      rentDateInfo: {
        rentCategory: 1,
        rentPeriod: '',
        presentDays: '',
        rentPeriodType: '',
        payMode: '',
      },
      pageTitle: `${MODE_TYPE_TEXT[this.mode] || '新增'}企业租赁方案`,
      baseDefaultValue: {
        orderTypeName: '企业订单',
        brandId: '',
        modelId: '',
      },
      baseEditConfig: [
        {
          el: 'text',
          itemConfig: { label: '方案ID', prop: 'id' },
        },
        {
          el: 'text',
          itemConfig: { label: '创建时间', prop: 'gmtCreate' },
        },
      ],
      baseRules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        brandId: [{ required: true, message: '请选择', trigger: 'change' }],
        orderTypeName: [{ required: true }],
        modelId: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      defaultTable: [],
      feeTableData: [],
      id: '',
      detailData: null,
      oLoading: {
        pageLoading: false,
        submit: false,
      },
    }
  },
  mounted() {
    this.pageConfig()
  },
  computed: {
    baseCloumn() {
      return [
        {
          el: 'input',
          itemConfig: {
            label: '方案名称',
            prop: 'name',
          },
          elConfig: {
            placeholder: '不对外展示，最多20字',
            clearable: true,
            maxlength: 20,
          },
        },
        {
          el: 'text',
          itemConfig: {
            label: '订单类型',
            prop: 'orderTypeName',
          },
        },
        {
          el: 'CarBrandSeriesModel',
          itemConfig: {
            prop: 'brandSeriesModel',
            ref: 'brandSeriesModelRef',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
      ]
    },
    isEdit() {
      return this.mode === MODE_TYPE.EDIT
    },
    hasSubmitPermission() {
      return this.judgePermission(
        this.isEdit ? 'enterprise_plan_edit' : 'enterprise_plan_create',
      )
    },
  },
  watch: {
    'baseDefaultValue.brandSeriesModel': {
      handler(val) {
        if (!val) return
        const { brandId, seriesId, modelId } = val
        this.baseDefaultValue.brandId = brandId
        this.baseDefaultValue.seriesId = seriesId
        this.baseDefaultValue.modelId = modelId
        this.$nextTick(() => {
          this.$refs.baseSearchBox.getRefs().clearValidate('brandId')
          this.$refs.baseSearchBox.getRefs().clearValidate('modelId')
        })
      },
      deep: true,
    },
  },
  methods: {
    pageConfig() {
      if (this.mode === MODE_TYPE.ADD) return
      const routeId = this.$route.query.id
      if (!routeId) {
        this.$message.error('url缺少ID参数')
        return
      }
      this.id = routeId
      this.getDetail()
    },
    async getDetail() {
      this.oLoading.pageLoading = true
      const { code, data } = await getEnterprisePlanDetail({ id: Number(this.id) })
      if (code === 1) {
        this.detailData = data
        this.setData(data)
      }
      this.oLoading.pageLoading = false
    },
    updateRentDateInfo(val, feeTableData) {
      this.rentDateInfo = { ...val }
      this.feeTableData = feeTableData
    },
    autoAnchor(toastFlag) {
      this.$refs.schemeRentInfo.autoAnchorPoint(toastFlag)
    },
    setData(data) {
      if (this.isEdit) {
        this.baseDefaultValue.id = this.id
        this.baseDefaultValue.gmtCreate = data.gmtCreate
      }
      this.baseDefaultValue.name = this.mode === MODE_TYPE.COPY ? `${data.name}-复制` : data.name
      this.baseDefaultValue.brandId = !this.validateIsEmptyValue(data.brandId)
        ? Number(data.brandId)
        : ''
      this.baseDefaultValue.seriesId = !this.validateIsEmptyValue(data.seriesId)
        ? Number(data.seriesId)
        : ''
      this.baseDefaultValue.modelId = !this.validateIsEmptyValue(data.modelId)
        ? Number(data.modelId)
        : ''
      this.baseDefaultValue.brandSeriesModel = {
        brandId: this.baseDefaultValue.brandId,
        seriesId: this.baseDefaultValue.seriesId,
        modelId: this.baseDefaultValue.modelId,
      }
      this.baseDefaultValue.introduction = data.introduction

      this.leaseInfoParams.rentCategory = data.rentCategory
      this.leaseInfoParams.rentPeriod = !this.validateIsEmptyValue(data.rentPeriod)
        ? String(data.rentPeriod)
        : ''
      this.leaseInfoParams.presentDays = data.presentDays ? String(data.presentDays) : ''
      this.leaseInfoParams.rentPeriodType = data.rentPeriodType

      this.rentDateInfo = { ...this.leaseInfoParams }
      this.defaultTable = data.orderPlanFeeList || []
    },
    submitHandle() {
      this.$refs.baseSearchBox.getRefs().validate((valid) => {
        if (!valid) {
          this.$message.error('请先将【方案基本信息】的必填字段填写完整')
          this.$refs.baseSearchBox.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
          return
        }
        const baseInfoData = { ...this.baseDefaultValue }
        const rentInfoData = this.$refs.schemeRentInfo.getFormData()
        if (!rentInfoData) return
        const tableData = this.$refs.schemeRentLeasePlanInfo.getFormData()
        if (!tableData) return

        delete baseInfoData.orderTypeName
        const params = {
          name: baseInfoData.name,
          modelId: baseInfoData.modelId,
          rentCategory: rentInfoData.rentCategory,
          rentPeriod: rentInfoData.rentPeriod,
          presentDays: rentInfoData.presentDays || 0,
          rentPeriodType: rentInfoData.rentPeriodType,
          payMode: this.rentDateInfo.payMode || '',
          rentFeeList: tableData,
        }

        if (this.isEdit && this.id) {
          params.id = Number(this.id)
          if (this.detailData) {
            params.state = this.detailData.state
          }
        } else {
          params.state = ENTERPRISE_PLAN_STATUS.ON
        }

        this.doSubmit(params)
      })
    },
    async doSubmit(params) {
      this.oLoading.submit = true
      const { code, msg } = await saveEnterprisePlan(params)
      if (code === 1) {
        this.$message.success(this.isEdit ? '修改成功' : '添加成功')
        this.$emit('submit-success')
      }
      this.oLoading.submit = false
    },
    handleCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped>
.orderConfig {
 margin-bottom: 0;
}
.lessMonth {
 margin-top: 20px;
}
.qs-scrollerBox {
  margin-right: 0
}
</style>
